// Application constants and configuration

// Environment and mode
export const IS_TEST_MODE = !process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY;

// API Configuration
export const OPENAI_SERVER_URL = process.env.REACT_APP_OPENAI_SERVER_URL || 'https://openai-server-lauren.vercel.app';
export const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME || 'ECHOO_AI';

// Database table names
export const TABLES = {
    ASSISTANTS: 'assistants',
    CONVERSATIONS: 'conversations',
    QUESTION_ANALYSIS_CACHE: 'question_analysis_cache',
    CONTEXT_CARDS_CACHE: 'context_cards_cache',
    INVITE_CODES: 'invite_codes',
    INVITE_CODE_USAGE: 'invite_code_usage',
    WAITLIST: 'waitlist',
} as const;

// Default colors
export const DEFAULT_COLORS = {
    PRIMARY: '#3B82F6',
    SECONDARY: '#1E40AF',
} as const;

// Error codes
export const ERROR_CODES = {
    TABLE_NOT_FOUND: 'PGRST205',
    FOREIGN_KEY_CONSTRAINT: '23503',
    UNIQUE_CONSTRAINT: '23505',
    NOT_ACCEPTABLE: '406',
    CONFLICT: '409',
    NO_ROWS_RETURNED: 'PGRST116',
} as const;

// Routes
export const ROUTES = {
    HOME: '/',
    LANDING: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    CREATE_ASSISTANT: '/create-assistant',
    EDIT_ASSISTANT: '/edit-assistant',
    ASSISTANT_CHAT: '/:uniqueUrl',
} as const;

// Test mode configuration
export const TEST_MODE_CONFIG = {
    MOCK_USER: {
        id: 'test-user-id',
        email: 'test@example.com',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
    },
    MOCK_ASSISTANT: {
        id: '1',
        user_id: 'test-user',
        name: 'Lauren Wang',
        pronouns: 'she/her',
        bio: 'Professional software engineer and AI enthusiast with 10+ years of experience in web development.',
        experience: 'Full-stack developer specializing in React, Node.js, and cloud technologies. Passionate about creating innovative AI solutions.',
        testimonials: 'Lauren is an excellent developer who consistently delivers high-quality work and brings creative solutions to complex problems.',
        other: 'Additional information about Lauren\'s background, interests, and any other relevant details that visitors might find helpful.',
        primary_color: DEFAULT_COLORS.PRIMARY,
        secondary_color: DEFAULT_COLORS.SECONDARY,
        unique_url: 'lauren-wang-test',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
    },
    MOCK_ASSISTANTS: [
        {
            id: '1',
            user_id: 'test-user',
            name: 'Lauren Wang',
            pronouns: 'she/her',
            bio: 'Professional software engineer and AI enthusiast with 10+ years of experience in web development.',
            experience: 'Full-stack developer specializing in React, Node.js, and cloud technologies. Passionate about creating innovative AI solutions.',
            testimonials: 'Lauren is an excellent developer who consistently delivers high-quality work and brings creative solutions to complex problems.',
            other: 'Additional information about Lauren\'s background, interests, and any other relevant details that visitors might find helpful.',
            primary_color: DEFAULT_COLORS.PRIMARY,
            secondary_color: DEFAULT_COLORS.SECONDARY,
            unique_url: 'lauren-wang-test',
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
        },
    ] as const,
};

// Form validation
export const VALIDATION = {
    MIN_NAME_LENGTH: 2,
    MAX_NAME_LENGTH: 15,
    MIN_PRONOUNS_LENGTH: 0,
    MAX_PRONOUNS_LENGTH: 20,
    MIN_BIO_LENGTH: 10,
    MAX_BIO_LENGTH: 500,
    MIN_EXPERIENCE_LENGTH: 10,
    MAX_EXPERIENCE_LENGTH: 1000,
    MIN_TESTIMONIALS_LENGTH: 10,
    MAX_TESTIMONIALS_LENGTH: 500,
    MIN_OTHER_LENGTH: 0,
    MAX_OTHER_LENGTH: 50000,
} as const;

// Pronoun options
export const PRONOUN_OPTIONS = [
    'he/him',
    'she/her',
    'they/them'
] as const;

// UI Configuration
export const UI = {
    MAX_MESSAGES_IN_CHAT: 50,
    MESSAGE_LOADING_DELAY: 1000,
    DEBOUNCE_DELAY: 300,
} as const;

// Messages for single Echoo approach
export const MESSAGES = {
    NO_ASSISTANT: {
        title: 'No Echoo Created',
        description: 'Create your personal Echoo to start chatting with visitors.',
        action: 'Create Echoo',
    },
    HAS_ASSISTANT: {
        title: 'Your Echoo',
        description: 'Manage your personal Echoo and view chat statistics.',
        action: 'Edit Echoo',
    },
} as const;
